<div class="dialog-header">
  <h3>{{ "create-part-derivation-modal.title" | translate }}</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog()"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content dialog-content-extended">
  <form [formGroup]="form" (ngSubmit)="save()">
    <!-- Part code -->
    <div fxLayout="row">
      <mat-form-field>
        <mat-label>{{ "input-part-code" | translate }}</mat-label
        ><input
          formControlName="partCode"
          matInput
          id="partDerivation-form-input-partCode"
          maxlength="30"
          (change)="verifyIfPartCodeAlreadyExists()"
        />
        <mat-error
          *ngIf="
            form.controls.partCode.touched &&
            form.controls.partCode.hasError('alreadyExists')
          "
          >{{
            "create-part-derivation-modal.part-code-pre-populated-message"
              | translate
          }}: {{ form.controls.partCode.value }}</mat-error
        >
        <mat-error
          *ngIf="
            form.controls.partCode.touched &&
            form.controls.partCode.hasError('required')
          "
          >{{ "required-part-code" | translate }}</mat-error
        >
        <mat-error
          *ngIf="
            form.controls.partCode.touched &&
            form.controls.partCode.hasError('pattern')
          "
          >{{
            "create-part-derivation-modal.invalid-code" | translate
          }}</mat-error
        >
      </mat-form-field>
    </div>
    <!-- Segments -->
    <div fxLayout="row">
      <mat-form-field>
        <mat-label>{{ "input-segment" | translate }}</mat-label
        ><mat-select
          formControlName="segment"
          id="partDerivation-form-input-segments"
        >
          <mat-option *ngFor="let segment of segments" [value]="segment.value">
            {{ segment.name }}
          </mat-option>
        </mat-select>
        <mat-error
          translate
          *ngIf="
            form.controls.segment.touched &&
            form.controls.segment.hasError('required')
          "
          >required-segment
        </mat-error>
      </mat-form-field>
    </div>
    <!--Part Manufacturer Autocomplete -->
    <div fxLayout="row">
      <app-smartfleet-part-manufacturer-driveb-auto-complete
        #partManufacturerAutocomplete
        class="mat-form-field"
        (onChange)="handlePartManufacturerChange($event)"
        [value]="form.controls.partManufacturerName.value"
        [required]="true"
        [disabled]="false"
        id="partDerivation-form-autoComplete-partManufacturer"
      >
      </app-smartfleet-part-manufacturer-driveb-auto-complete>
    </div>
    <div class="dialog-actions">
      <button mat-raised-button color="primary" type="submit">
        {{ "button-send" | translate }}
      </button>
    </div>
  </form>
</div>
